/* PBC native wishlist with named lists (no app). Saved in this browser's localStorage, so it works for guests.
   Storage: pbc_wishlist_v2 = {v:2, last:<list id>, lists:[{id, n:<name>, items:[{h:<handle>, t:<ms>}]}]}.
   The first list (id "default", "My Wishlist") always exists and can't be deleted. MAX items in total across lists.
   Old pbc_wishlist_v1 data (flat [{h,t}]) is moved into the default list on first load.
   Buttons: [data-pbc-wl-toggle][data-handle]. Count: [data-pbc-wl-count]. Page: <div data-pbc-wl-page>.
   Release-date sort (Nov 3): each item can also carry d:<'YYYY-MM-DD' or '' if the book has no date> and dt:<ms checked>.
   d comes from the heart's data-release (product metafield book.release_date) or, for older items, from
   /products/<handle>?view=pbc-wl-data (templates/product.pbc-wl-data.liquid). Sort choice: localStorage pbc_wishlist_sort.
   Optional account sync: if window.PBC_WL.syncUrl is set (e.g. an app proxy path) and a customer is signed in,
   the full state is POSTed there after each change. Nothing is set by default, so no request is made. */
(function () {
  'use strict';
  var KEY = 'pbc_wishlist_v2', KEY1 = 'pbc_wishlist_v1';
  var MAX = 1000;     /* total saved items across all lists */
  var PAGE = 24;      /* wishlist page: cards shown per "Show more" step */
  var CONC = 6;       /* wishlist page: product requests in flight at once */
  var DEF = 'default', DEFNAME = 'My Wishlist';
  var SORTKEY = 'pbc_wishlist_sort', STALE = 7 * 864e5;   /* re-check a saved release date after 7 days */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = window.PBC_WL || {};

  /* ---------- storage ---------- */
  function okItem(i) { return i && typeof i.h === 'string' && i.h; }
  function blank() { return { v: 2, last: DEF, lists: [{ id: DEF, n: DEFNAME, items: [] }] }; }
  function clean(s) {
    var out = blank(), ids = {};
    if (s && Array.isArray(s.lists)) {
      s.lists.forEach(function (l) {
        if (!l || typeof l.id !== 'string' || ids[l.id]) return;
        var seen = {}, items = (Array.isArray(l.items) ? l.items : []).filter(function (i) { if (!okItem(i) || seen[i.h]) return false; seen[i.h] = 1; return true; });
        var name = typeof l.n === 'string' && l.n.trim() ? l.n.trim().slice(0, 60) : (l.id === DEF ? DEFNAME : 'List');
        ids[l.id] = 1;
        if (l.id === DEF) { out.lists[0].n = name; out.lists[0].items = items; } else out.lists.push({ id: l.id, n: name, items: items });
      });
    }
    out.last = s && ids[s.last] ? s.last : DEF;
    return out;
  }
  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) return clean(JSON.parse(raw));
      var st = blank(), v1 = JSON.parse(localStorage.getItem(KEY1) || '[]');
      if (Array.isArray(v1) && v1.length) {
        st = clean({ lists: [{ id: DEF, n: DEFNAME, items: v1 }] });
        st.lists[0].items = st.lists[0].items.slice(0, MAX);
        localStorage.setItem(KEY, JSON.stringify(st));   /* one-time move of v1 data; v1 key is left as is */
      }
      return st;
    } catch (e) { return blank(); }
  }
  function total(st) { return st.lists.reduce(function (n, l) { return n + l.items.length; }, 0); }
  function capTo(st) {
    /* Over the total cap: drop the oldest saved item (any list), like the single list did. */
    var n = total(st);
    while (n > MAX) {
      var bl = null, bk = -1, bt = Infinity;
      st.lists.forEach(function (l) { l.items.forEach(function (i, k) { if ((i.t || 0) < bt) { bt = i.t || 0; bl = l; bk = k; } }); });
      if (!bl) break;
      bl.items.splice(bk, 1); n--;
    }
  }
  function save(st) {
    capTo(st);
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
    paint();
    document.dispatchEvent(new CustomEvent('pbc:wishlist', { detail: { count: handles(st).length, total: total(st) } }));
    queueSync(st);
  }
  /* Account sync hook. Off unless PBC_WL.syncUrl is set by a backend that can write customer metafield pbc.wishlist. */
  var syncTimer;
  function queueSync(st) {
    if (!cfg.syncUrl || !cfg.cid) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var body = { v: 2, lists: st.lists.map(function (l) { return { n: l.id === DEF ? '' : l.n, h: l.items.map(function (i) { return i.h; }) }; }) };
      try { fetch(cfg.syncUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).catch(function () {}); } catch (e) {}
    }, 1500);
  }
  function getList(st, id) { for (var i = 0; i < st.lists.length; i++) if (st.lists[i].id === id) return st.lists[i]; return null; }
  function byName(st, n) { n = String(n || '').trim().toLowerCase(); for (var i = 0; i < st.lists.length; i++) if (st.lists[i].n.toLowerCase() === n) return st.lists[i]; return null; }
  function handles(st) { var seen = {}, out = []; st.lists.forEach(function (l) { l.items.forEach(function (i) { if (!seen[i.h]) { seen[i.h] = 1; out.push(i.h); } }); }); return out; }
  function inList(l, h) { return l.items.some(function (i) { return i.h === h; }); }
  function newId() { return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

  /* ---------- API ---------- */
  function read() { var st = load(), out = [], seen = {}; st.lists.forEach(function (l) { l.items.forEach(function (i) { if (!seen[i.h]) { seen[i.h] = 1; out.push(i); } }); }); return out; }
  function has(h) { return load().lists.some(function (l) { return inList(l, h); }); }
  function add(h, id, d) {
    var st = load(), l = getList(st, id || st.last) || st.lists[0];
    if (!inList(l, h)) { var it = { h: h, t: Date.now() }; if (typeof d === 'string') { it.d = d; it.dt = Date.now(); } l.items.unshift(it); }
    st.last = l.id; save(st); return l.id;
  }
  function remove(h, id) {
    var st = load();
    st.lists.forEach(function (l) { if (!id || l.id === id) l.items = l.items.filter(function (i) { return i.h !== h; }); });
    save(st);
  }
  function move(h, from, to) {
    var st = load(), a = getList(st, from), b = getList(st, to);
    if (!a || !b || a === b) return;
    var it = a.items.filter(function (i) { return i.h === h; })[0] || { h: h, t: Date.now() };
    a.items = a.items.filter(function (i) { return i.h !== h; });
    if (!inList(b, h)) b.items.unshift(it);
    st.last = b.id; save(st);
  }
  function createList(name) {
    name = String(name || '').trim().slice(0, 60);
    if (!name) return null;
    var st = load(), ex = byName(st, name);
    if (ex) return ex.id;
    var l = { id: newId(), n: name, items: [] };
    st.lists.push(l); st.last = l.id; save(st); return l.id;
  }
  function renameList(id, name) {
    name = String(name || '').trim().slice(0, 60);
    var st = load(), l = getList(st, id), ex = byName(st, name);
    if (!l || !name || (ex && ex !== l)) return false;
    l.n = name; save(st); return true;
  }
  function deleteList(id) {
    if (id === DEF) return false;
    var st = load(); st.lists = st.lists.filter(function (l) { return l.id !== id; });
    if (st.last === id) st.last = DEF;
    save(st); return true;
  }
  function toggle(h) { if (has(h)) { remove(h); return false; } add(h); return true; }

  /* ---------- hearts + count ---------- */
  function paint() {
    var st = load(), set = {}, hs = handles(st);
    hs.forEach(function (h) { set[h] = 1; });
    var btns = document.querySelectorAll('[data-pbc-wl-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], on = !!set[b.getAttribute('data-handle')];
      /* PBC speed: only write when the value changes (avoids style invalidation on every repaint) */
      var ap = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== ap) b.setAttribute('aria-pressed', ap);
      var lab = b.querySelector('[data-pbc-wl-label]');
      var lt = on ? 'Saved to wishlist' : 'Add to wishlist';
      if (lab && lab.textContent !== lt) lab.textContent = lt;
      var t = b.getAttribute('data-title') || '';
      var al = (on ? 'Remove ' : 'Add ') + t + (on ? ' from wishlist' : ' to wishlist');
      if (b.getAttribute('aria-label') !== al) b.setAttribute('aria-label', al);
    }
    var counts = document.querySelectorAll('[data-pbc-wl-count]');
    for (var j = 0; j < counts.length; j++) {
      var ct = hs.length > 99 ? '99+' : String(hs.length);
      if (counts[j].textContent !== ct) counts[j].textContent = ct;
      var hid = hs.length === 0; if (counts[j].hidden !== hid) counts[j].hidden = hid;
    }
  }

  /* ---------- "Save to list" popover (shown after a heart saves an item) ---------- */
  var pop, popTimer, popH, popList;
  function popEl() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'pbc-wl-pop'; pop.setAttribute('data-pbc-wl-pop', ''); pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', 'Save to list'); pop.hidden = true;
    document.body.appendChild(pop);
    pop.addEventListener('pointerenter', function () { clearTimeout(popTimer); });
    return pop;
  }
  function hidePop() { clearTimeout(popTimer); if (pop) pop.hidden = true; }
  function showPop(h, listId, open) {
    var st = load(), l = getList(st, listId) || st.lists[0], el = popEl();
    popH = h; popList = l.id;
    var html = '<div class="pbc-wl-pop__row"><p class="pbc-wl-pop__msg" role="status">Saved to <strong>' + esc(l.n) + '</strong></p>' +
      '<button type="button" class="pbc-wl-pop__link" data-pbc-wl-pop-change aria-expanded="' + (open ? 'true' : 'false') + '">Change list</button>' +
      '<button type="button" class="pbc-wl-pop__x" data-pbc-wl-pop-close aria-label="Close">&times;</button></div>';
    if (open) {
      html += '<ul class="pbc-wl-pop__lists" role="list">' + st.lists.map(function (x) {
        return '<li><button type="button" data-pbc-wl-pop-pick="' + esc(x.id) + '"' + (x.id === l.id ? ' aria-current="true"' : '') + '><span>' + esc(x.n) + '</span><span class="pbc-wl-pop__n">' + x.items.length + '</span></button></li>';
      }).join('') + '</ul><button type="button" class="pbc-wl-pop__new" data-pbc-wl-pop-new>+ New list</button>';
    }
    el.innerHTML = html; el.hidden = false;
    clearTimeout(popTimer);
    if (!open) popTimer = setTimeout(hidePop, 4500);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pbc-wl-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var rd = b.hasAttribute('data-release') ? normDate(b.getAttribute('data-release')) : undefined;
    if (has(h)) { remove(h); hidePop(); } else { showPop(h, add(h, null, rd), false); }
  }, true);

  document.addEventListener('click', function (e) {
    if (!pop || pop.hidden || !e.target.closest) return;
    if (!e.target.closest('[data-pbc-wl-pop]')) { if (!e.target.closest('[data-pbc-wl-toggle]')) hidePop(); return; }
    if (e.target.closest('[data-pbc-wl-pop-close]')) return hidePop();
    if (e.target.closest('[data-pbc-wl-pop-change]')) return showPop(popH, popList, true);
    var pk = e.target.closest('[data-pbc-wl-pop-pick]');
    if (pk) { var to = pk.getAttribute('data-pbc-wl-pop-pick'); move(popH, popList, to); showPop(popH, to, false); renderPage(); return; }
    if (e.target.closest('[data-pbc-wl-pop-new]')) {
      var n = window.prompt('Name your new list');
      var id = n && createList(n);
      if (id) { move(popH, popList, id); showPop(popH, id, false); renderPage(); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hidePop(); });

  window.addEventListener('storage', function (e) { if (e.key === KEY) { paint(); renderPage(); } });

  /* Repaint when the theme swaps in new product cards (filters, infinite scroll, recommendations). */
  var queued = false;
  /* PBC speed: only repaint when added nodes actually contain a heart or a count badge
     (timers, app widgets and pixels mutate the DOM constantly; those no longer trigger a repaint). */
  var WL_SEL = '[data-pbc-wl-toggle],[data-pbc-wl-count]';
  function wlRelevant(muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var k = 0; k < a.length; k++) {
        var n = a[k];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches(WL_SEL)) || (n.querySelector && n.querySelector(WL_SEL))) return true;
      }
    }
    return false;
  }
  new MutationObserver(function (muts) {
    if (queued || !wlRelevant(muts)) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- wishlist page ---------- */
  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    function withDelims(num, dec, thou, sep) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p.length > 1 ? p[0] + sep + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var cache = {};
  /* Resolves to the product, null if it no longer exists (404), or 'err' on a temporary failure (retried once, not cached). */
  function normDate(v) { var m = /^(\d{4}-\d{2}-\d{2})/.exec(String(v || '')); return m ? m[1] : ''; }
  /* Product JSON plus its release date, from the theme's product.pbc-wl-data template (one request per book).
     Falls back to /products/<handle>.js (no date) if that template isn't in the theme. */
  var viewOk = true;
  function fetchProduct(h, tries) {
    var url = root + 'products/' + encodeURIComponent(h);
    var req = viewOk
      ? fetch(url + '?view=pbc-wl-data', { credentials: 'same-origin' }).then(function (r) {
          if (r.status === 404) return null;
          if (!r.ok) throw r.status;
          return r.text().then(function (t) {
            try { var j = JSON.parse(t); if (!j || !j.product || !('release_date' in j)) throw 0; j.product._rd = normDate(j.release_date); j.product._rs = j.release_status || ''; return j.product; }
            catch (x) { viewOk = false; return fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r2) { if (r2.ok) return r2.json(); if (r2.status === 404) return null; throw r2.status; }); }
          });
        })
      : fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (r.ok) return r.json(); if (r.status === 404) return null; throw r.status; });
    return req
      .catch(function (e) {
        if (tries > 0) return new Promise(function (ok) { setTimeout(ok, 800); }).then(function () { return fetchProduct(h, tries - 1); });
        return 'err';
      });
  }
  function getProduct(h) {
    if (!cache[h]) {
      cache[h] = fetchProduct(h, 1).then(function (p) { if (p === 'err') delete cache[h]; return p; });
    }
    return cache[h];
  }
  /* Fetch a list of handles with at most CONC requests at a time. */
  function getProducts(hs) {
    var out = new Array(hs.length), next = 0;
    function worker() {
      if (next >= hs.length) return Promise.resolve();
      var k = next++;
      return getProduct(hs[k]).then(function (p) { out[k] = p; return worker(); });
    }
    var ws = [];
    for (var w = 0; w < Math.min(CONC, hs.length); w++) ws.push(worker());
    return Promise.all(ws).then(function () { return out; });
  }

  function card(h, p) {
    if (p === 'err') {
      return '<li class="pbc-wl-item pbc-wl-item--gone"><div class="pbc-wl-item__body"><p class="pbc-wl-item__title">This item could not be loaded right now. Refresh to try again.</p>' +
        moveSel(h) + '<button type="button" class="pbc-wl-remove link" data-pbc-wl-remove="' + esc(h) + '">Remove</button></div></li>';
    }
    if (!p) {
      return '<li class="pbc-wl-item pbc-wl-item--gone"><div class="pbc-wl-item__body"><p class="pbc-wl-item__title">This item is no longer available.</p>' +
        moveSel(h) + '<button type="button" class="pbc-wl-remove link" data-pbc-wl-remove="' + esc(h) + '">Remove</button></div></li>';
    }
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var multi = (p.variants || []).length > 1;
    var price = v.price != null ? v.price : p.price;
    var cmp = v.compare_at_price;
    var url = root + 'products/' + p.handle;
    var image = (v.featured_image && v.featured_image.src) || p.featured_image;
    var status = p.available ? '<span class="pbc-wl-status pbc-wl-status--in">Available</span>' : '<span class="pbc-wl-status pbc-wl-status--out">Sold out</span>';
    var rd = p._rd !== undefined ? p._rd : (itemOf(h) || {}).d;
    var dateLine = rd ? '<span class="pbc-wl-date">' + (rd >= today() ? 'Releases ' : 'Released ') + fmtDate(rd) + '</span>' : '';
    var action;
    if (!p.available) {
      action = '<a class="button button--secondary pbc-wl-atc" href="' + url + '">View item</a>';
    } else if (multi) {
      action = '<a class="button button--primary pbc-wl-atc" href="' + url + '">Choose options</a>';
    } else {
      action = '<button type="button" class="button button--primary pbc-wl-atc" data-pbc-wl-add="' + v.id + '">Add to cart</button>';
    }
    return '<li class="pbc-wl-item">' +
      '<a class="pbc-wl-item__media" href="' + url + '">' + (image ? '<img src="' + esc(img(image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="600">' : '') + '</a>' +
      '<div class="pbc-wl-item__body">' +
      '<a class="pbc-wl-item__title" href="' + url + '">' + esc(p.title) + '</a>' +
      '<div class="pbc-wl-item__price">' + (cmp && cmp > price ? '<s>' + money(cmp) + '</s> ' : '') + '<span>' + money(price) + '</span></div>' +
      dateLine + status + action +
      '<p class="pbc-wl-msg" role="status" aria-live="polite"></p>' +
      moveSel(h) +
      '<button type="button" class="pbc-wl-remove link" data-pbc-wl-remove="' + esc(h) + '">Remove</button>' +
      '</div></li>';
  }

  /* ---------- release-date sort ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function today() { var n = new Date(); return n.getFullYear() + '-' + ('0' + (n.getMonth() + 1)).slice(-2) + '-' + ('0' + n.getDate()).slice(-2); }
  function fmtDate(d) { var a = d.split('-'); return MONTHS[+a[1] - 1] + ' ' + (+a[2]) + ', ' + a[0]; }
  var SORTS = [
    ['release', 'Release date: upcoming first'],
    ['release-new', 'Release date: newest first'],
    ['release-old', 'Release date: oldest first'],
    ['added', 'Recently saved']
  ];
  function sortMode() { var m; try { m = localStorage.getItem(SORTKEY); } catch (e) {} return SORTS.some(function (s) { return s[0] === m; }) ? m : 'release'; }
  function itemOf(h) { var st = load(), out = null; st.lists.forEach(function (l) { l.items.forEach(function (i) { if (!out && i.h === h) out = i; }); }); return out; }
  /* Default 'release': upcoming books soonest first, then released books newest first, then books with no date.
     Ties (and undated books) keep most-recently-saved first. */
  function sorted(items, mode) {
    var t = today(), arr = items.slice();
    function added(a, b) { return (b.t || 0) - (a.t || 0); }
    if (mode === 'added') return arr.sort(added);
    return arr.sort(function (a, b) {
      var da = a.d || '', db = b.d || '';
      if (!da || !db) return da ? -1 : db ? 1 : added(a, b);
      if (da === db) return added(a, b);
      if (mode === 'release-new') return da < db ? 1 : -1;
      if (mode === 'release-old') return da < db ? -1 : 1;
      var ua = da >= t, ub = db >= t;
      if (ua !== ub) return ua ? -1 : 1;
      return ua ? (da < db ? -1 : 1) : (da < db ? 1 : -1);
    });
  }
  /* Store fresh dates on every copy of each handle (an item can sit in more than one list). Doesn't repaint. */
  function setDates(map) {
    var st = load(), now = Date.now(), changed = false;
    st.lists.forEach(function (l) { l.items.forEach(function (i) { if (i.h in map && map[i.h] !== null) { if (i.d !== map[i.h]) changed = true; i.d = map[i.h]; i.dt = now; changed = true; } }); });
    if (changed) try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
  }
  /* Look up dates for items saved before this feature (or not checked for a week) so the whole list can be sorted. */
  function backfill(items) {
    var now = Date.now(), need = items.filter(function (i) { return typeof i.d !== 'string' || !i.dt || now - i.dt > STALE; }).map(function (i) { return i.h; });
    if (!need.length || !viewOk) return Promise.resolve(false);
    return getProducts(need).then(function (ps) {
      var map = {};
      need.forEach(function (h, k) { var p = ps[k]; map[h] = p && p !== 'err' && p._rd !== undefined ? p._rd : (p === null ? '' : null); });
      setDates(map); return true;
    });
  }
  function sortBar(el) {
    var tools = el.querySelector('[data-pbc-wl-tools]'), bar = el.querySelector('[data-pbc-wl-sort]');
    if (!bar) {
      bar = document.createElement('label'); bar.className = 'pbc-wl-sort'; bar.setAttribute('data-pbc-wl-sort', '');
      bar.innerHTML = '<span>Sort</span><select data-pbc-wl-sort-select>' + SORTS.map(function (s) { return '<option value="' + s[0] + '">' + s[1] + '</option>'; }).join('') + '</select>';
      tools.insertBefore(bar, tools.firstChild);
    }
    bar.querySelector('select').value = sortMode();
  }

  /* ---------- wishlist page: list picker + 24-at-a-time grid ---------- */
  var rendering = 0, shown = PAGE, view = null, pageLists = null;
  function moveSel(h) {
    if (!pageLists || pageLists.length < 2) return '';
    return '<label class="pbc-wl-move"><span class="visually-hidden">Move to list</span><select data-pbc-wl-move="' + esc(h) + '"><option value="">Move to…</option>' +
      pageLists.filter(function (l) { return l.id !== view; }).map(function (l) { return '<option value="' + esc(l.id) + '">' + esc(l.n) + '</option>'; }).join('') + '</select></label>';
  }
  function moreBox(el, grid) {
    var box = el.querySelector('[data-pbc-wl-more]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'pbc-wl-more';
      box.setAttribute('data-pbc-wl-more', '');
      box.innerHTML = '<p class="pbc-wl-more__status" role="status" aria-live="polite"></p>' +
        '<button type="button" class="button button--secondary" data-pbc-wl-more-btn>Show more</button>';
      grid.parentNode.insertBefore(box, grid.nextSibling);
    }
    return box;
  }
  function listBar(el, st, cur) {
    var bar = el.querySelector('[data-pbc-wl-lists]');
    if (!bar) { bar = document.createElement('div'); bar.setAttribute('data-pbc-wl-lists', ''); var g = el.querySelector('[data-pbc-wl-grid]'); g.parentNode.insertBefore(bar, g); }
    bar.className = 'pbc-wl-lists';
    bar.innerHTML = '<label class="pbc-wl-lists__pick"><span>List</span><select data-pbc-wl-list-select>' +
      st.lists.map(function (l) { return '<option value="' + esc(l.id) + '"' + (l.id === cur.id ? ' selected' : '') + '>' + esc(l.n) + ' (' + l.items.length + ')</option>'; }).join('') +
      '</select></label><div class="pbc-wl-lists__actions">' +
      '<button type="button" class="pbc-wl-remove" data-pbc-wl-list-new>New list</button>' +
      '<button type="button" class="pbc-wl-remove" data-pbc-wl-list-rename>Rename</button>' +
      (cur.id === DEF ? '' : '<button type="button" class="pbc-wl-remove" data-pbc-wl-list-delete>Delete list</button>') +
      '</div><p class="pbc-wl-lists__total">' + st.lists.length + (st.lists.length === 1 ? ' list' : ' lists') + ' · ' + total(st) + ' of ' + MAX + ' saved</p>';
  }
  function renderPage() {
    var el = document.querySelector('[data-pbc-wl-page]');
    if (!el) return;
    var st = load(), cur = getList(st, view) || getList(st, st.last) || st.lists[0];
    view = cur.id; pageLists = st.lists;
    var mode = sortMode();
    var list = sorted(cur.items, mode);
    var grid = el.querySelector('[data-pbc-wl-grid]');
    var empty = el.querySelector('[data-pbc-wl-empty]');
    var tools = el.querySelector('[data-pbc-wl-tools]');
    var box = moreBox(el, grid);
    var any = total(st) > 0 || st.lists.length > 1;
    listBar(el, st, cur);
    sortBar(el);
    el.querySelector('[data-pbc-wl-lists]').hidden = !any;
    empty.hidden = list.length > 0;
    tools.hidden = list.length === 0;
    if (!list.length) { grid.innerHTML = ''; box.hidden = true; rendering++; return; }
    var run = ++rendering;
    var btn = box.querySelector('[data-pbc-wl-more-btn]');
    var status = box.querySelector('.pbc-wl-more__status');
    grid.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    var page;
    var dated = mode === 'added' ? Promise.resolve(false) : backfill(cur.items);
    if (mode !== 'added') { box.hidden = false; status.textContent = 'Sorting by release date…'; }
    dated.then(function (did) {
      if (run !== rendering) return null;
      if (did) { cur = getList(load(), view) || cur; list = sorted(cur.items, mode); }
      page = list.slice(0, shown);
      return getProducts(page.map(function (i) { return i.h; }));
    }).then(function (ps) {
      if (!ps || run !== rendering) return;
      var fresh = {};
      page.forEach(function (i, k) { var p = ps[k]; if (p && p !== 'err' && p._rd !== undefined && p._rd !== (i.d || '')) fresh[i.h] = p._rd; });
      if (Object.keys(fresh).length) setDates(fresh);
      grid.innerHTML = page.map(function (i, k) { return card(i.h, ps[k]); }).join('');
      grid.removeAttribute('aria-busy');
      var left = list.length - page.length;
      box.hidden = list.length <= PAGE;
      status.textContent = 'Showing ' + page.length + ' of ' + list.length;
      btn.hidden = left <= 0;
      btn.disabled = false;
      btn.textContent = 'Show more (' + left + ' more)';
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-pbc-wl-list-select]')) { view = t.value; shown = PAGE; var st = load(); st.last = view; try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (x) {} renderPage(); return; }
    if (t.matches && t.matches('[data-pbc-wl-move]') && t.value) { move(t.getAttribute('data-pbc-wl-move'), view, t.value); renderPage(); }
    if (t.matches && t.matches('[data-pbc-wl-sort-select]')) { try { localStorage.setItem(SORTKEY, t.value); } catch (x) {} shown = PAGE; renderPage(); }
  });

  function refreshCartBubble() {
    return fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var html = s && s['cart-icon-bubble'];
      var target = document.getElementById('cart-icon-bubble');
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.shopify-section') || doc.body;
      target.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var more = e.target.closest('[data-pbc-wl-more-btn]');
    if (more) { e.preventDefault(); shown += PAGE; renderPage(); return; }
    var rm = e.target.closest('[data-pbc-wl-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-pbc-wl-remove'), view); renderPage(); return; }
    if (e.target.closest('[data-pbc-wl-list-new]')) { var n = window.prompt('Name your new list'); var id = n && createList(n); if (id) { view = id; shown = PAGE; renderPage(); } return; }
    if (e.target.closest('[data-pbc-wl-list-rename]')) {
      var st = load(), cur = getList(st, view) || st.lists[0], nn = window.prompt('Rename list', cur.n);
      if (nn != null && !renameList(cur.id, nn)) window.alert('That name is empty or already used.');
      renderPage(); return;
    }
    if (e.target.closest('[data-pbc-wl-list-delete]')) {
      var s2 = load(), c2 = getList(s2, view);
      if (c2 && c2.id !== DEF && window.confirm('Delete "' + c2.n + '" and the ' + c2.items.length + ' items in it?')) { deleteList(c2.id); view = DEF; shown = PAGE; renderPage(); }
      return;
    }
    var clr = e.target.closest('[data-pbc-wl-clear]');
    if (clr) {
      e.preventDefault();
      var s3 = load(), c3 = getList(s3, view) || s3.lists[0];
      if (window.confirm('Remove everything from "' + c3.n + '"?')) { c3.items = []; save(s3); renderPage(); }
      return;
    }
    var addBtn = e.target.closest && e.target.closest('[data-pbc-wl-add]');
    if (!addBtn) return;
    e.preventDefault();
    var msg = addBtn.parentNode.querySelector('.pbc-wl-msg');
    addBtn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(addBtn.getAttribute('data-pbc-wl-add')), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      addBtn.disabled = false;
      if (!res.ok) { if (msg) msg.textContent = (res.j && (res.j.description || res.j.message)) || 'Could not add to cart.'; return; }
      if (msg) msg.innerHTML = 'Added. <a href="' + root + 'cart">View cart</a>';
      refreshCartBubble();
      if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pbc-wishlist' }); } catch (x) {} }
    }).catch(function () { addBtn.disabled = false; if (msg) msg.textContent = 'Could not add to cart.'; });
  });

  window.PBCWishlist = { read: read, add: add, remove: remove, toggle: toggle, has: has, move: move, createList: createList, renameList: renameList, deleteList: deleteList, lists: function () { return load().lists; } };

  /* One-time seed from the account (Growave import), customer metafield pbc.wishlist:
     {"v":2,"lists":[{"n":name,"h":[handles]}]}  or the old flat [handles] (goes to the default list).
     Merged by list name (default list for a blank or "My Wishlist" name), deduped per list, local items first. */
  function serverLists(srv) {
    if (Array.isArray(srv)) return [{ n: '', h: srv }];
    if (srv && typeof srv === 'object') {
      if (Array.isArray(srv.lists)) return srv.lists.filter(function (l) { return l && Array.isArray(l.h); }).map(function (l) { return { n: typeof l.n === 'string' ? l.n : '', h: l.h }; });
      if (Array.isArray(srv.handles)) return [{ n: '', h: srv.handles }];
    }
    return [];
  }
  function mergeServer() {
    try {
      var c = window.PBC_WL || {};
      var sl = serverLists(c.server);
      if (!c.cid || !sl.length) return;
      var flag = 'pbc_wl_merged_v2_' + c.cid;
      if (localStorage.getItem(flag)) return;
      var st = load(), now = Date.now(), tot = total(st);
      for (var k = 0; k < sl.length && tot < MAX; k++) {
        var name = String(sl[k].n || '').trim().slice(0, 60);
        var l = !name || name.toLowerCase() === DEFNAME.toLowerCase() ? st.lists[0] : byName(st, name);
        var made = false;
        if (!l) { l = { id: newId() + k, n: name, items: [] }; made = true; }
        var seen = {};
        l.items.forEach(function (i) { seen[i.h] = 1; });
        for (var j = 0; j < sl[k].h.length && tot < MAX; j++) {
          var h = sl[k].h[j];
          if (typeof h === 'string' && h && !seen[h]) { seen[h] = 1; l.items.push({ h: h, t: now }); tot++; }
        }
        if (made && l.items.length) st.lists.push(l);
      }
      localStorage.setItem(KEY, JSON.stringify(st));
      localStorage.setItem(flag, String(now));
    } catch (e) {}
  }
  function init() { mergeServer(); paint(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
